import { Component, OnInit } from '@angular/core';
import { LayoutService } from '../../../../Services/layout/layout.service';

@Component({
	selector: 'progress-meter-dr',
	templateUrl: './progress-meter-dr.component.html',
	styleUrls: ['./progress-meter-dr.component.scss'],
})
export class ProgressMeterDrComponent {
	progressMeterStages: string[] = ['Auto Info', 'Residency Info', 'Bundle Rate'];
	activeStageIndex: number;

	constructor(private layoutService: LayoutService) {}

	// async ngOnInit() {
	//   this.layoutService.staticLayout.subscribe((data) => {
	//     if (data) {
	//       this.progressMeterStages = data.data.metadata.progressMeter.sections;
	//       this.activeStageIndex = this.progressMeterStages.findIndex((stage) => stage.active);
	//       console.log(this.activeStageIndex);
	//     }
	//   });
	// }

	progressMeterClicked(stage): void {
		const dataObj = {
			event: 'GAEvent',
			route: window.location.pathname,
			eventCategory: 'Home_Quoting',
			eventAction: 'BannerClick',
			CurrentItemNameInHTML: '',
			DesiredItemNameinHTML: 'ProgressMeter_' + stage.split(' ').join('') + '_Inactive',
			eventLabel: 'ProgressMeter_' + stage.split(' ').join('') + '_Inactive',
			eventValue: '',
			callback: '',
			nonInteraction: 'nonInteraction',
		};
	}
}
